<template>
  <div class="box-outer">
    <div class="title">{{ title }}</div>
    <div :class="{ 'radio-group--invalid': isInvalid }" class="radio-group">
      <div v-for="option in options" :key="option.value" class="radio-field">
        <div class="radio">
          <input
            :checked="option.value === defaultValue"
            :value="option.value"
            :id="option.value"
            type="radio"
            class="input"
            name="name"
            @change="handleChange(option.value)"
          />
          <div class="cover">
            {{ option.label }}
          </div>
        </div>
      </div>
      <error-component :errors="errors" class="errors" />
    </div>
  </div>
</template>

<script>
import ErrorComponent from '@/components/Error'

export default {
  components: {
    ErrorComponent
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    defaultValue: {
      type: [String, Number],
      default: ''
    },
    errors: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isErrorVisible: false
    }
  },
  computed: {
    error() {
      return this.isErrorVisible && this.errors[0] ? this.errors[0] : ''
    },
    isInvalid() {
      return !!this.error
    }
  },
  methods: {
    showErrors() {
      this.isErrorVisible = true
    },
    handleChange(value) {
      this.showErrors()
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-group--invalid {
  .cover {
    border-color: $error;
  }
}

.radio-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.radio-field {
  display: flex;
  width: calc(50% - 10px);
  &:not(:last-child) {
    margin-bottom: 24px;
  }
}

.radio {
  width: 100%;
  height: 40px;
  position: relative;
  margin-top: -3px;
  @include media-down(md) {
    margin-top: 1px;
  }
}

.cover,
.input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.input {
  position: absolute;
  z-index: 1;
  opacity: 0;
  margin: 0;
}

.cover {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  background-color: #fff;
  background-size: 62%;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 4px;
  transition: all 0.5s ease;
  input:checked + & {
    background-color: $navy;
    color: #fff;
  }
}

.errors {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.title {
  @include label;
  margin-bottom: 8px;
}

.box-outer {
  margin-top: 28px;
}
</style>
